import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { DetailRow } from "./baseDetails";
import snakeToPascal from "../../tools";

export default function modelDataValueUpdateLstUpdateDetails({ row }) {
    const keys = row.old_value ? Object.keys(row.old_value) : [];

    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <DetailRow label="Index">
                <span className="font-mono">{row.index}</span>
            </DetailRow>

            {/* Changes table */}
            {keys.length > 0 && (
                <div className="mt-3 overflow-hidden rounded-lg border border-slate-200">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="bg-slate-50 border-b border-slate-200">
                                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">Field</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">Before</th>
                                <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">After</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {keys.map((key, idx) => {
                                const oldVal = row.old_value[key];
                                const newVal = row.new_value[key];
                                const changed = oldVal !== newVal;

                                return (
                                    <tr key={idx} className={changed ? 'bg-amber-50/50' : ''}>
                                        <td className="px-3 py-2 text-slate-700">{snakeToPascal(key)}</td>
                                        <td className="px-3 py-2">
                                            <span className={changed ? 'text-red-600 bg-red-50 px-1.5 py-0.5 rounded' : 'text-slate-600'}>
                                                {oldVal ?? 'empty'}
                                            </span>
                                        </td>
                                        <td className="px-3 py-2">
                                            <span className={changed ? 'text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded' : 'text-slate-600'}>
                                                {newVal ?? 'empty'}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </ModelDataValueUpdateDetailsBase>
    );
}
